export const config = {
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? ''
};
